import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { trackEvent, scrollToId } from "@/lib/analytics";

const slides = [
  {
    url: "https://images.unsplash.com/photo-1769149255670-aa0ad6428dd6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjByZXNvcnQlMjBiZWFjaHxlbnwwfHx8fDE3ODI4Mzk4Mzd8MA&ixlib=rb-4.1.0&q=85",
    alt: "Resort pool overlooking the ocean",
  },
  {
    url: "https://images.unsplash.com/photo-1599640842225-85d111c60e6b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwyfHxjcnVpc2UlMjBzaGlwJTIwb2NlYW58ZW58MHx8fHwxNzgyODM5ODM3fDA&ixlib=rb-4.1.0&q=85",
    alt: "Cruise ship sailing on open sea",
  },
  {
    url: "https://images.unsplash.com/photo-1539635278303-d4002c07eae3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwyfHxncm91cCUyMGZyaWVuZHMlMjB2YWNhdGlvbnxlbnwwfHx8fDE3ODI4Mzk4Mzd8MA&ixlib=rb-4.1.0&q=85",
    alt: "Group of friends enjoying a vacation together",
  },
];

export const Hero = () => {
  const [active, setActive] = useState(0);

  useEffect(() => {
    const t = setInterval(() => setActive((a) => (a + 1) % slides.length), 5500);
    return () => clearInterval(t);
  }, []);

  return (
    <section id="hero" data-testid="hero-section" className="relative min-h-[100svh] w-full overflow-hidden">
      {slides.map((s, i) => (
        <div
          key={i}
          className="absolute inset-0 transition-opacity duration-[1400ms] ease-in-out"
          style={{ opacity: i === active ? 1 : 0 }}
        >
          <img src={s.url} alt={s.alt} className="h-full w-full object-cover" />
        </div>
      ))}
      <div className="absolute inset-0 bg-gradient-to-t from-black/65 via-black/35 to-black/30" />

      <div className="relative z-10 flex min-h-[100svh] items-center">
        <div className="max-w-7xl mx-auto px-6 md:px-12 w-full">
          <div className="max-w-2xl animate-fade-up">
            <p className="uppercase text-xs sm:text-sm tracking-[0.25em] font-semibold text-white/80 mb-5">
              Curated Travel by KIS Living
            </p>
            <h1 className="font-serif text-5xl sm:text-6xl lg:text-7xl font-semibold leading-[1.02] tracking-tight text-white">
              Beautiful travel,
              <br />
              made simple.
            </h1>
            <p className="mt-6 text-base sm:text-lg leading-relaxed text-white/90 max-w-xl">
              Discover curated resort stays, cruises, group travel experiences, and travel
              essentials selected to help you plan with ease and enjoy more of the journey.
            </p>
            <div className="mt-9 flex flex-col sm:flex-row gap-4">
              <Button
                data-testid="hero-join-button"
                onClick={() => {
                  trackEvent("cta_click", { location: "hero", cta: "join_travel_list" });
                  scrollToId("lead-capture");
                }}
                className="rounded-full bg-terracotta hover:bg-terracotta-hover text-white px-8 py-6 text-base h-auto"
              >
                Join the Travel List
              </Button>
              <Button
                data-testid="hero-offers-button"
                onClick={() => {
                  trackEvent("cta_click", { location: "hero", cta: "view_offers" });
                  scrollToId("featured");
                }}
                variant="outline"
                className="rounded-full bg-white/10 border-white/70 text-white hover:bg-white hover:text-ink px-8 py-6 text-base h-auto backdrop-blur-sm"
              >
                View Current Offers
              </Button>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 flex gap-3">
        {slides.map((_, i) => (
          <button
            key={i}
            data-testid={`hero-dot-${i}`}
            onClick={() => setActive(i)}
            aria-label={`Go to slide ${i + 1}`}
            className={`h-2 rounded-full transition-all duration-300 ${
              i === active ? "w-8 bg-white" : "w-2 bg-white/50"
            }`}
          />
        ))}
      </div>
    </section>
  );
};
